<template>
    <div>
        <v-dialog width="430" v-model="show_dialog">
            <v-card class="pb-2">
                <v-card-title class="blue white--text">
                    Are you sure ?
                </v-card-title>
                <v-card-text class="mt-2 text-body-2">
                    you want to update the insurance status to {{ status }} ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        outlined
                        color="red"
                        @click="show_dialog = false"
                    >
                        cancel
                    </v-btn>
                    <v-btn
                        color="green"
                        class="elevation-0 white--text"
                        @click="updateInsuranceStatus()"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
/* Goes through the shared KarroFin data layer, the same as the list behind it.
   Both have to read from one source: with the dialog writing to the live
   endpoint while the table showed demo rows, confirming here appeared to do
   nothing -- the row it updated was not the row on screen. */
import api from "@/app-js/karrofin/api";

export default {
    data() {
        return{
            show_dialog: false,
            id: '',
            status: '',
            saving: false,
        }
    },
    methods: {
        openDialog(id, status) {
            this.show_dialog = true;
            this.id = id;
            this.status = status;
        },
        updateInsuranceStatus() {
            const self = this;
            self.saving = true;
            api
                .setInsuranceStatus(self.id, self.status)
                .then(() => {
                    self.$emit('update');
                })
                .catch(() => {
                    self.$store.dispatch('snackbar/setSnackbar', {
                        flag: true,
                        text: 'Could not update the insurance status',
                        color: 'error',
                    });
                })
                .finally(() => {
                    self.saving = false;
                    self.show_dialog = false;
                });
        }
    }
}
</script>